import React, { Suspense } from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import { store } from "./store/store";
import { App } from "./App";
import Wrapper from "./core/language-wrapper";
import "./web.config";
const BuyNowTrigger = React.lazy(() =>
  import("../src/containers/BuyNowPopup/BuyNowPopupTrigger")
);

const MapPopupTrigger = React.lazy(() =>
  import("../src/containers/BuyNowPopup/MapPopupTrigger")
);



class MyElement extends HTMLElement {
  connectedCallback() {
    ReactDOM.render(
      <Suspense fallback={<div>Loading...</div>}>
        <Wrapper>
          <Provider store={store}>
            <App />
          </Provider>
        </Wrapper>
      </Suspense>,
      this
    );
  }

  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
}

class buyNowElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener(
      "click",
      function () {
        var pid;
        pid = this.getAttribute("product");
        let pElem = document.createElement("div");
        let shadowRoot = this.attachShadow({ mode: "open" }).appendChild(pElem);
        ReactDOM.render(
          <Suspense fallback={<div>Loading...</div>}>
            <Wrapper>
              <Provider store={store}>
                <BuyNowTrigger pid={pid} />
              </Provider>
            </Wrapper>
          </Suspense>,
          shadowRoot
        );
      },
      true
    );
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
}
class mapElement extends HTMLElement {
  connectedCallback() {
    // Make it keyboard-accessible
    if (!this.hasAttribute("tabindex")) {
      this.setAttribute("tabindex", "0");
    }

    // Shared event handler
    const handleInteraction = () => {
      const pid = this.getAttribute("product");
      const brand = this.getAttribute("brand");
      const tab = this.getAttribute("tab");
      const prodId = sessionStorage.getItem("productId");

      let pElem = document.createElement("div");
      let shadowRoot = this.appendChild(pElem);

      sessionStorage.setItem("productId", pid);

      ReactDOM.render(
        <Suspense fallback={<div className="pl-fallback-loading">Loading...</div>}>
          <Wrapper>
            <Provider store={store}>
              <MapPopupTrigger pid={pid} tab={tab} />
            </Provider>
          </Wrapper>
        </Suspense>,
        shadowRoot
      );
    };

    // Click listener
    this.addEventListener("click", handleInteraction, { once: true, capture: true });

    // Enter key listener
    this.addEventListener(
      "keydown",
      (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          handleInteraction();
        }
      },
      { once: true, capture: true }
    );
  }

  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
}

// class mapElement extends HTMLElement {
//   connectedCallback() {
//     this.addEventListener(
//       "click",
//       function () {
//         var pid;

//         pid = this.getAttribute("product");
//         const brand = this.getAttribute("brand");
//         const prodId = sessionStorage.getItem("productId");
//         var tab = this.getAttribute("tab");
//         if (prodId !== pid && brand !== "5555") {
//           let pElem = document.createElement("div");
//           let shadowRoot = this.appendChild(pElem);

//           sessionStorage.setItem("productId", pid);
//           ReactDOM.render(
//             <Suspense
//               fallback={<div className="pl-fallback-loading">Loading...</div>}
//             >
//               <Wrapper>
//                 <Provider store={store}>
//                   <MapPopupTrigger pid={pid} tab={tab} />
//                 </Provider>
//               </Wrapper>
//             </Suspense>,
//             shadowRoot
//           );
//         } else {
//           let pElem = document.createElement("div");
//           let shadowRoot = this.appendChild(pElem);

//           sessionStorage.setItem("productId", pid);
//           ReactDOM.render(
//             <Suspense
//               fallback={<div className="pl-fallback-loading">Loading...</div>}
//             >
//               <Wrapper>
//                 <Provider store={store}>
//                   <MapPopupTrigger pid={pid} tab={tab} />
//                 </Provider>
//               </Wrapper>
//             </Suspense>,
//             shadowRoot
//           );
//         }
//       },
//       true,
//       { once: true }
//     );
//   }
//   disconnectedCallback() {
//     ReactDOM.unmountComponentAtNode(this);
//   }
// }

window.customElements.define("bsi-product-locator", MyElement);
window.customElements.define("bsi-locator-buy-button", buyNowElement);
window.customElements.define("bsi-map-popup", mapElement);
// if (document.getElementsByTagName("bsi-product-locator").length) {
//   let getTheme = document.getElementsByTagName("bsi-product-locator")[0];
//   let theme = getTheme.getAttribute("theme");

//   if (theme) {
//     import(`./brandtheme/${theme}.scss`)
//       .catch(() => ('./brandtheme/pl-main.scss'))
//   }
//   else if (theme === 'whitelabel') {
//     // return false;
//   }
//   else {
//     import('./brandtheme/pl-main.scss')
//   }
// }
